
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/africa/why-partner",
      function () {
        return require("private-next-pages/africa/why-partner.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/africa/why-partner"])
      });
    }
  